var map = {
	"./loaders": 68695,
	"./loaders.json": 68695,
	"./logo-impulse-primary": 38747,
	"./logo-impulse-primary.json": 38747,
	"./spinner-middle-gray": 34892,
	"./spinner-middle-gray.json": 34892
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 44305;